import { Select } from 'antd';
import styled from 'styled-components';

export const SelectStyled = styled(Select)`
  width: 100%;
`;
